/* eslint no-shadow:0 */
import axios from 'axios';

const data = {
  qoute: {},
  healthQuote: {},
  healthQuoteResponse: {},
  DPQuote: {},
  DPQuoteResponse: {},
};
const getters = {
  getQoute: (state) => state.qoute,
  getHealthQuote: (state) => state.healthQuote,
  getHealthQuoteResponse: (state) => state.healthQuoteResponse,
  getDPQuote: (state) => state.DPQuote,
  getDPQuoteResponse: (state) => state.DPQuoteResponse,
};

const mutations = {
  setQuotation(state, data) {
    state.qoute = data;
  },
  setHealthQuoteResponse(state, data) {
    state.healthQuoteResponse = data;
  },
  setHealthQuotation(state, data) {
    state.healthQuote = { ...state.healthQuote, ...data };
  },
  clearHealthQuotation(state) {
    state.healthQuote = {};
  },
  setDPQuoteResponse(state, data) {
    state.DPQuoteResponse = data;
  },
  setDPQuotation(state, data) {
    state.DPQuote = { ...state.DPQuote, ...data };
  },
  clearDPQuotation(state) {
    state.DPQuote = {};
  },
};
const actions = {
  getQuotation: async (context, id) => {
    await axios.get(`/customer/quotation?quoteId=${id}`).then((response) => {
      context.commit('setQuotation', response.data.data);
    });
  },
};

export default {
  namespaced: true,
  state: data,
  getters,
  actions,
  mutations,
};
